export const costs = [
  'Sleepless nights searching for ways to translate complex surveying concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how surveying connects to construction projects, land development or their communities.",
  "Awkward silences when a student asks how to calculate coordinates or what misclosure means and you don't have a clear answer.",
  'Weekends lost building lesson plans, field survey projects and assessments from scratch over and over.',
  'Uncertainty about how to teach instrument operation, GNSS technology or topographic mapping without adequate resources.',
];
